"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorPublished = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/ReactiveComponent"));
const hooks_1 = require("../../hooks");
const SensorPublished = () => {
    const flagsHook = (0, hooks_1.useFlags)();
    if (!flagsHook.flags["reactify-search:flag_sensor_published"]) {
        return null;
    }
    return (react_1.default.createElement(ReactiveComponent_1.default, { componentId: "SensorPublished", customQuery: () => ({
            query: {
                match: {
                    published: true,
                },
            },
        }) }));
};
exports.SensorPublished = SensorPublished;
//# sourceMappingURL=SensorPublished.js.map